// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"4368":"css/admin-app.6895","7186":"css/app.6895"}[chunkId] + ".css";
};